import React, { Fragment } from 'react';
  
  const Configuration = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                        Configuration
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Customize Interview Cheater to match your needs and preferences.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Application Settings
                    </h2>
                    <div style={{height: '1.5rem'}}></div>
                    <h2 style={{color: '#fff)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        You can manage your language preferences in the <a href='/settings' style={{textDecoration: 'underline', color: 'inherit'}}>settings</a> page.
                    </h2>
                    <div style={{height: '1.5rem'}}></div>
                    <h2 style={{color: '#fff)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Currently, we offer support for Python, Java, Javascript, Go, C++, Kotlin, and Swift.
                    </h2>
                </div>
            </div>
        </Fragment>
    );
  }
  
  export default Configuration;
  